import { Component, OnInit } from '@angular/core';
import { ThemeModule } from '../../theme.module';
import { MenuItem } from 'primeng/api';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'dum-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  items: MenuItem[];
  imgDuminvalFooter: string;
  constructor() {}

  ngOnInit(): void {
    this.imgDuminvalFooter = environment.logo_duminval_footer;
    this.items = [
      {
        label: 'Objetivo',
        icon: null,
        routerLink: ['/objetivo'],
        routerLinkActiveOptions: { exact: true },
      },
      {
        label: 'Gestión',
        icon: null,
        routerLink: ['/gestion'],
        routerLinkActiveOptions: { exact: true },
      },
      {
        label: 'Historia',
        icon: null,
        routerLink: ['/historia'],
        routerLinkActiveOptions: { exact: true },
      },
      {
        label: 'Tipo de plazas',
        icon: null,
        routerLink: ['/plazas'],
        routerLinkActiveOptions: { exact: true },
      },
      {
        label: 'Tipo de usuarios',
        icon: null,
        routerLink: ['/usuarios'],
        routerLinkActiveOptions: { exact: true },
      },
      {
        label: 'Trámites disponibles',
        icon: null,
        routerLink: ['/tramites'],
        routerLinkActiveOptions: { exact: true },
      },
      {
        label: 'Plano',
        icon: null,
        routerLink: ['/plano'],
        routerLinkActiveOptions: { exact: true },
      },
      {
        label: 'Apps disponibles',
        icon: null,
        routerLink: ['/apps'],
        routerLinkActiveOptions: { exact: true },
      },
      {
        label: 'Contacto',
        icon: null,
        routerLink: ['/contacto'],
        routerLinkActiveOptions: { exact: true },
      },
    ];
  }
}
